module.exports = __webpack_public_path__ + "static/img/website_3.3352661.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/website_3.png
// module id = oS6h
// module chunks = 1